var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeletedTileIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 22,
  height: 22
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "red",
  fillRule: "nonzero",
  points: "2.16066017 0.0393398282 21.9606602 19.8393398 19.8393398 21.9606602 0.0393398282 2.16066017"
}))));
export default SvgDeletedTileIcon;